import { post, postSme } from './request';

export async function uploadImages(imgArr: any[], ref: string, id: string | Blob, url: any, isSme?: boolean) {
  const promises: any = [];
  imgArr.forEach((img: any) => {
    const formData = new FormData();
    formData.append(ref, id);
    formData.append('file', img);
    promises.push(
      isSme
        ? postSme(url, formData, { 'Content-Type': 'multipart/form-data' })
        : post(url, formData, { 'Content-Type': 'multipart/form-data' }),
    );
  });
  await Promise.all(promises);
}
